import { FC } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Box, Step, StepButton, Stepper } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { RECEPTION_PATHS } from 'src/utils/receptionRoutes';

const steps = [
    { path: RECEPTION_PATHS.register, label: 'Manage Client Register' },
    { path: RECEPTION_PATHS.checkIn, label: 'Check-in' },
    { path: RECEPTION_PATHS.payment, label: 'payment' },
    { path: RECEPTION_PATHS.transactions, label: 'transactions' },
    { path: RECEPTION_PATHS.report, label: 'report' }
];

const ReceptionStepper: FC = () => {
    const { t }: { t: any } = useTranslation();
    const navigate = useNavigate();
    const { pathname } = useLocation();

    const activeStep = steps.findIndex((step) => pathname.endsWith(step.path));

    return (
        <Box mb={3}>
            <Stepper nonLinear activeStep={activeStep === -1 ? 0 : activeStep}>
                {steps.map((step) => (
                    <Step key={step.path}>
                        <StepButton onClick={() => navigate(step.path)}>
                            {t(step.label)}
                        </StepButton>
                    </Step>
                ))}
            </Stepper>
        </Box>
    );
};

export default ReceptionStepper;
